import React from 'react';
import 'react-day-picker/lib/style.css';
import ReactDOM from 'react-dom';
import { ToastContainer } from 'react-toastify';
import { BrowserRouter } from 'react-router-dom';
import './styles/styles.scss';
import { QueryClientProvider } from 'react-query';
import App from './App';
import queryClient from './utils/queryClient';

const app = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      <ToastContainer />
    </QueryClientProvider>
  </React.StrictMode>
);

ReactDOM.render(app, document.getElementById('root'));
